var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveMeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.41663 3.58337C4.41663 2.89302 4.97627 2.33337 5.66663 2.33337H10.75C11.4403 2.33337 12 2.89302 12 3.58337V10.4167C12 11.1071 11.4403 11.6667 10.75 11.6667H4.41663V3.58337Z",
    fill: "#FF9A9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16663 5.25037H10.25",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99866 8.00037H7.99866",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveMeal);
export default __webpack_public_path__ + "static/media/activeMeal.e8eaf6698f591ad84c6f9f48e328ff92.svg";
export { ForwardRef as ReactComponent };